import * as types from './actionTypes';

const initialCredentials = {
  userName: '',
  fullName: '',
  isActive: false,
  isDemoUser: false,
  isMasterUser: false
};

const initialState = {
  attemptingLogin: false,
  showDemoModal:false,
  attemptingLogout: false,
  authenticated: false,
  contextLoaded: false,
  credentials: initialCredentials,
  subscriptions: [],
  activeSubscriptionId: 0,
  managementLink: ''
};

export default function reducer(state = initialState, action = {}) {
  switch(action.type) {
    case types.CUSTOMER_LOGIN_ATTEMPT:
      return {
        ...state,
        attemptingLogin: true
      };
    case types.CUSTOMER_LOGIN_SUCCESS:
      return {
        ...state,
        attemptingLogin: false,
        authenticated: true,
        credentials: {
          userName: action.payload.userName,
          fullName: action.payload.fullName,
          isActive: action.payload.isActive,
          isDemoUser: action.payload.isDemoUser,
          isMasterUser: action.payload.isMasterUser
        }
      };
    case types.CUSTOMER_LOGIN_FAIL:
      return {
        ...state,
        attemptingLogin: false
      };
      case types.SHOW_DEMO_MODAL:
      return {
        ...state,
        showDemoModal: true
      };
      case types.HIDE_DEMO_MODAL:
      return {
        ...state,
        showDemoModal: false
      };
    case types.CUSTOMER_LOGOUT:
      return {
        ...state,
        authenticated: false,
        contextLoaded: false,
        credentials: initialCredentials,
        subscriptions: [],
        activeSubscriptionId: 0
      };
    case types.CUSTOMER_CONTEXT_RECEIVED:
      return {
        ...state,
        contextLoaded: true,
        credentials: {
          userName: action.payload.userName,
          fullName: action.payload.fullName,
          isActive: action.payload.isActive,
          isDemoUser: action.payload.isDemoUser,
          isMasterUser: action.payload.isMasterUser
        },
        subscriptions: action.payload.subscriptionList,
        activeSubscriptionId: action.payload.activeSubscriptionId,
        managementLink: action.payload.managementLink
      };
    case types.TOKEN_LOGIN_SUCCESS:
      return {
        ...state,
        authenticated: true     
      };
    case types.SET_ACTIVE_SUBSCRIPTION:
      // We don't need to set the state if it's already equal, that way we avoid an unneeded render
      if(state.activeSubscriptionId === action.payload.activeSubscriptionId) {
        return state;
      } 
      return {
        ...state,
        activeSubscriptionId: action.payload.activeSubscriptionId,
        managementLink: action.payload.managementLink
      };
    case types.UPDATE_LABEL_STYLES:
    {
      let subscriptions = JSON.parse(JSON.stringify(state.subscriptions));
      for(let x = 0; x < subscriptions.length; x++)
      {
        if(subscriptions[x].id === state.activeSubscriptionId)
          subscriptions[x].styles = action.payload.LabelStyles;
      }
      return {
        ...state,
        subscriptions: subscriptions
      };
    }
    case types.UPDATE_LABEL_LOGOS:
    {
      let subscriptions = JSON.parse(JSON.stringify(state.subscriptions));
      for(let x = 0; x < subscriptions.length; x++)
      {
        if(subscriptions[x].id === state.activeSubscriptionId)
          subscriptions[x].logos = action.payload.LabelLogos;
      }
      return {
        ...state,
        subscriptions: subscriptions
      };
    }
    case types.UPDATE_LABEL_OFFSET:
    {
      let subscriptions = JSON.parse(JSON.stringify(state.subscriptions));
      for(let x = 0; x < subscriptions.length; x++)
      {
        if(subscriptions[x].id === state.activeSubscriptionId)
        {
          subscriptions[x].pageOffset = action.payload.pageOffset;


          subscriptions[x].isPaperSizeLetter = action.payload.isPaperSizeLetter;

          subscriptions[x].usePLUCode= action.payload.usePLUCode;

          subscriptions[x].useUSMetrics= action.payload.useUSMetrics;

          subscriptions[x].labelTitleOrder= action.payload.labelTitleOrder;
        }
      }
      return {
        ...state,
        subscriptions: subscriptions
      };
    }
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/modules/customer/reducer.js
 **/